export default [

     {
          path: '/physical-course-material',
          name: 'PhysicalCourseMaterial',
          component: () => import("@/views/Page/PhysicalCourseMaterial/PhysicalCourseMaterial.vue"),
           meta: {
               title: 'GRC | PhysicalCourseMaterial',
          },
     }
];